import { useEffect, useState } from "react";
import AudioPlayer from "../../../../components/AudioPlayer/AudioPlayer";
import { CHATBOX_STRINGS, RetrieveContentItem } from "../../types";
import "./MiddleView.scss";

interface MiddleViewProps {
  currentQuestions: RetrieveContentItem[] | null;
  currentQuestionIdx: number;
  isOwnStory: boolean;
  /** URI of the question audio — rendered as an inline speaker button */
  questionAudio?: string;
  /** Whether to show the audio player (delayed after question change) */
  showAudioPlayer?: boolean;
}

/** Reveals text character-by-character (mobile uses react-native-typewriter-effect) */
function useTypewriter(text: string, speed = 40) {
  const [displayed, setDisplayed] = useState("");
  useEffect(() => {
    setDisplayed("");
    if (!text) return;
    let i = 0;
    const id = setInterval(() => {
      i++;
      setDisplayed(text.slice(0, i));
      if (i >= text.length) clearInterval(id);
    }, speed);
    return () => clearInterval(id);
  }, [text, speed]);
  return displayed;
}

function MiddleView({
  currentQuestions,
  currentQuestionIdx,
  isOwnStory,
  questionAudio,
  showAudioPlayer,
}: MiddleViewProps) {
  const question = !isOwnStory
    ? currentQuestions?.[currentQuestionIdx]?.question ?? ""
    : CHATBOX_STRINGS.myStory;
  const typed = useTypewriter(question);

  return (
    <div className="chat-middle">
      <div className="chat-middle__bubble">
        <p className="chat-middle__question">{typed}</p>
        {showAudioPlayer && questionAudio && (
          <div className="chat-middle__speaker">
            <AudioPlayer uri={questionAudio} autoPlay variant="compact" />
          </div>
        )}
      </div>
    </div>
  );
}

export default MiddleView;
